

import React, { memo } from 'react';
import onEnterPressed from '@shootsta/on-enter-pressed';
import cx from 'classnames';
import Icon from '../../Icon';
import LucideIcon from '../../LucideIcon';
import { Camera } from 'lucide-react';
import Text from '../../Text';
import InitialsPlaceholder from './InitialsPlaceholder';
import { IMAGE, IMAGE_ICON, IMAGE_EDIT } from '../styles/image';
import '../styles/_image.scss';




























function Image({
  imageUrl,
  defaultImageIcon = '',
  placeholderText,
  placeholderTextSize,
  width,
  height,
  onClick,
  editButtonTitle,
  circular,
  rounded,
  isEditableImage,
  backgroundPosition,
  backgroundSize,
  defaultIconColour,
  defaultIconBackground,
  defaultIconSize,
  defaultIconSubtitle,
  defaultIconAnimated,
  imageElement
}) {
  if (imageElement) {
    const styles = {
      width,
      height,
      minWidth:
      width,
      objectFit: backgroundSize,
      objectPosition: backgroundPosition
    };

    const imageSrc = `${imageElement.sourceUrl}.${imageElement.sourceExtension}`;

    /* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
    return (
      <picture>
        <source srcSet={`${imageElement.sourceUrl}`} type="image/webp" />
        <source
          srcSet={imageSrc}
          type={`image/${imageElement.sourceExtension}`} />

        <img
          style={styles}
          alt={imageElement.alt}
          loading="lazy"
          className={cx(
            'image',
            IMAGE({ clickable: Boolean(onClick), circular, rounded }),
            {
              'image--clickable': Boolean(onClick),
              'image--circular': circular
            }
          )}
          src={imageSrc}
          onClick={onClick}
          onKeyDown={onEnterPressed({ onClick })}
          role="button"
          tabIndex={onClick ? 0 : void 0} />

      </picture>);

  }

  const placeholder = placeholderText && placeholderText.trim() ?

  <InitialsPlaceholder
    string={placeholderText}
    size={height}
    fontSize={placeholderTextSize} /> :



  <div
    className={cx(
      'image__icon',
      IMAGE_ICON({
        background: defaultIconBackground,
        width,
        height,
        defaultIconSize,
        color: defaultIconColour,
        hasSubtitle: Boolean(defaultIconSubtitle)
      })
    )}>

        <Icon
      name={defaultImageIcon}
      color={defaultIconColour}
      size={defaultIconSize}
      animated={defaultIconAnimated} />

        {
    defaultIconSubtitle ?

    <Text
      centered
      noMargin="bottom"
      label
      className="image__icon__subtitle">

                {defaultIconSubtitle}
              </Text> :

    null}

      </div>;


  const styles = {
    backgroundImage: imageUrl && `url(${imageUrl})`,
    width,
    height,
    minWidth: width,
    backgroundPosition,
    backgroundSize: circular ? 'cover' : backgroundSize
  };

  return (
    <div
      onClick={onClick}
      onKeyDown={onEnterPressed({ onClick })}
      className={cx(
        'image',
        IMAGE({ clickable: Boolean(onClick), circular, rounded }),
        {
          'image--clickable': Boolean(onClick),
          'image--circular': circular
        }
      )}
      role="button"
      tabIndex={onClick ? 0 : void 0}
      style={styles}>

      {!imageUrl ? placeholder : null}
      {
      Boolean(onClick) && isEditableImage ?

      <div className={cx('image__edit', IMAGE_EDIT)}>
              <LucideIcon icon={Camera} color="white" size={12} />
              <p>{editButtonTitle}</p>
            </div> :

      null}

    </div>);

}

Image.defaultProps = {
  defaultImageIcon: 'organisation',
  width: '100px',
  height: '100px',
  editButtonTitle: 'Edit',
  backgroundPosition: 'center',
  backgroundSize: 'contain',
  defaultIconColour: 'white',
  defaultIconBackground: 'parthenon'
};

export default memo(Image);